import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as defineCustomElement$1 } from './p-Da2lAZSv.js';

const componentHeaderCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;background-color:var(--jw-theme-surface-level0-bg-color);border-bottom:1px solid var(--jw-theme-surface-border-border-color);box-sizing:border-box;color:var(--jw-theme-surface-text-description-color);display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;font-weight:600;gap:1rem;letter-spacing:-.0004em;line-height:normal;line-height:1.25rem;padding:1rem}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}";

const WuiComponentHeader = /*@__PURE__*/ proxyCustomElement(class WuiComponentHeader extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return (h(Host, { key: 'ad99125231b31b3bbeb3662db6faafb6e6240060' }, this.icon && h("wui-icon", { key: 'ba9c10efc230008fb12a367393bec5ce6eccdc29', name: this.icon, size: "md" }), this.label && h("span", { key: '93db7d7ad433827f6bb8f912dbcda1d91c2f9208' }, this.label), h("slot", { key: '6b25f29df7408658958cb2da731a2eb55affef5e' })));
    }
    static get style() { return componentHeaderCss; }
}, [257, "wui-component-header", {
        "label": [1],
        "icon": [1]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-component-header", "wui-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-component-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiComponentHeader);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiComponentHeader as W, defineCustomElement as d };
